import axiosInstance from "../../services/AxiosInstance";



// In ChangePasswordAction.js or a new ForgotPasswordAction.js
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const CLEAR_FORGOT_PASSWORD_STATE = "CLEAR_FORGOT_PASSWORD_STATE";



export const forgotPasswordAction = (email) => {
  return async (dispatch) => {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });

    try {
      const response = await axiosInstance.post("/admin/forgotPassword", {
        email,
      });

      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
        payload: response.data.message || "Password reset link sent",
      });

      return response.data;
    } catch (error) {
      dispatch({
        type: FORGOT_PASSWORD_FAILURE,
        payload:
          error.response?.data?.message || error.message || "Failed to send reset link",
      });
      throw error;
    }
  };
};

export const clearForgotPasswordState = () => ({
  type: CLEAR_FORGOT_PASSWORD_STATE,
});

